const CheckPermission = (user, permission) => {
    return user.level === 'admin' || ((user.level === 'accounting' || user.level === 'operator') && user.rules && user.rules.indexOf(permission) >= 0);
};

const PriceFormat = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const SearchFormat = (value) => {
    return value.split('/').join('').split('ك').join('ک').split('ي').join('ی');
    //return value.split('/').join('').split('ك').join('ک').split('ی').join('ي');
}

export { CheckPermission, PriceFormat, SearchFormat};